function Loader() {
  return (
    <div
      style={{
        width: "100dvw",
        height: "80dvh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <h3>Loading Page...</h3>
    </div>
  );
}

export default Loader;
